export default __webpack_public_path__ + "static/media/I2P_Logo.ce0c6fd6.png";